import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../../../../common/CmnContext';
import { LiveReserveContext } from '../../../../LiveLessonReseveContext';


function LiveReserveSelectInstructorModalItem(props: any) {

  const isPc = useContext(cmnContext).isPc;
  const {
    instId, setInstId,
    setDetailInstId,
  } = useContext(LiveReserveContext);

  const inst = props.inst;
  const setIsDispModal = props.setIsDispModal;
  const listWidth = props.listWidth;
  // 講師情報から画像取得
  const getInstImg = props.getInstImg;
  // 講師の趣味・スコア情報
  const getInstDetailInfo = props.getInstDetailInfo;

  const imgSize = isPc? listWidth/7 : listWidth/4;

  const [imgSrc, setImgSrc] = useState<string>('');
  const [dispInfo, setDispInfo] = useState<string>('');

  const [isSelected, setIsSelected] = useState<boolean>(false);


  useEffect(() => {
    if(inst) {
      // 画像
      const newImgSrc = getInstImg(inst);
      setImgSrc(newImgSrc);

      // 講師情報
      const newDispInfo = getInstDetailInfo(inst);
      setDispInfo(newDispInfo);
    }
  }, [inst])


  useEffect(() => {
    setIsSelected(instId == inst.inst_id);
  }, [instId, inst])

  const onClickInst = () => {
    setInstId(inst.inst_id);
    setIsDispModal(false);
  }


  return (
    <div
      key={inst.inst_id}
      style={{
        display: 'flex',
        textAlign: 'left',
        alignItems: 'center',
        padding: isPc? '15px 2%' : '10px 3%',
      }}
    >

      {imgSrc &&
        <img
          className="img-rounded img-responsive"
          style={{
            width: imgSize,
            height: imgSize,
            objectFit: 'cover',
            marginRight: '10px',
          }}
          src={imgSrc}
        />
      }

      <div style={{flex: 1}}>
        <p style={{margin: 0, fontWeight: 'bold'}}>{inst.name} 講師</p>
        {/* ★SPEAKOUT-1853 選択中のレッスン時間で予約できる枠が無い講師も一覧に出るので、
            「残り0枠」ではなく状態として書く。
            ★「（日時をリクエスト）」は付けない。カード内で2行に折り返して「残り◯枠」と
              高さが揃わなくなるうえ、選んだ直後に日程欄が
              「この講師・レッスン時間で予約できる空き枠が現在ありません」＋黄色い案内に
              変わるので、ここで説明しきる必要がない（実機確認 E-4 の指摘）。 */}
        {inst.schedule_count > 0 ?
          <p style={{margin: 0, color: 'red', fontWeight: 'bold'}}>残り{inst.schedule_count}枠</p>
        :
          <p style={{margin: 0, color: '#777', fontWeight: 'bold'}}>空き枠なし</p>
        }

        {dispInfo &&
          <p style={{
              margin: 0,
              fontSize: '12px',
              display: '-webkit-box',
              WebkitLineClamp: 2, // 2行まで
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
          }}>{dispInfo}</p>
        }

        {/* ★SPEAKOUT-1853 一覧の名前と趣味の抜粋だけでは講師を選べないので、
            プロフィールとレビューを読める「詳細」を並べる（中身は講師紹介ページの埋め込み） */}
        <div style={{display: 'flex', gap: '5px', marginTop: '5px'}}>
          <button
            type="button"
            className={isSelected? 'btn btn-warning' : 'btn btn-success'}
            style={{
              flex: 2,
              padding: '5px 10px',
              whiteSpace: 'normal',
            }}
            onClick={onClickInst}
            disabled={isSelected}
          >
            {isSelected? '選択中' : '選択' }
          </button>
          <button
            type="button"
            className="btn btn-default"
            style={{
              flex: 1,
              padding: '5px 10px',
              whiteSpace: 'normal',
            }}
            onClick={() => setDetailInstId(String(inst.inst_id))}
          >
            詳細
          </button>
        </div>
      </div>

    </div>
  );
}
  
export default LiveReserveSelectInstructorModalItem;